import { finalExp, passwordErrorMessage } from 'utils/validation'
import { passwordForgot, passwordReset } from 'rest/urls'
import useTranslation from 'hooks/useTranslation'
import Submit from 'components/inputs/Submit'
import { useHistory } from 'react-router-dom'
import { useEffect, useState } from 'react'
import Input from 'components/inputs/Input'
import { STATUS } from 'utils/constants'
import { POST } from 'rest/request'
import { loginPath } from 'utils/login'
import '../style.scss'

const Reset = () => {
  const [form, setForm] = useState({})
  const [status, setStatus] = useState(STATUS.idle)
  const [warning, setWarning] = useState({
    email: false,
    password: false,
    passwordSec: false,
  })

  const { replace, location: { pathname, search } } = useHistory()
  const { t } = useTranslation('form')

  const isToken = search.includes('token')
  const isOnBoarding = search.includes('onboarding=1')
  const isLoading = status === STATUS.pending
  const refs = []

  useEffect(() => {
    if (!search) return
    const query = new URLSearchParams(search)
    const email = query.get('login')
    if (email) setForm({ email })
  }, [pathname, search])


  const changeHandler = e => {
    if (!e) return
    const { name, value } = e.target
    setForm({
      ...form,
      [name]: value
    })
    if (value && warning[name] && (
      (name === 'email') ||
      (name === 'password' && value.match(finalExp.password)) ||
      (name === 'passwordSec' && value === form.password))) {
      setWarning({
        ...warning,
        [name]: false
      })
    }
  }

  const blurHandler = e => {
    if (!e) return
    const { name, value } = e.target
    let warn = false

    switch (name) {
      case 'password':
        warn = passwordErrorMessage(value, t)
        break

      case 'passwordSec':
        warn = form.password !== form.passwordSec ? t('passwordsDoNotMatch') : false
        break
      default: warn = false
    }

    if (warn !== warning[name]) setWarning({
      ...warning,
      [name]: warn,
    })
  }

  const submit = () => {
    if (isToken) {
      if (form.password && form.password.match(finalExp.password) && form.password === form.passwordSec) {
        const serachParams = new URLSearchParams(search)
        const serachParamsObject = Object.fromEntries(serachParams.entries())
        const body = { login: form.email, password: form.password, ...serachParamsObject }
        fetch(body, passwordReset)

      } else {
        setWarning({
          email: false,
          password: passwordErrorMessage(form.password, t),
          passwordSec: form.password !== form.passwordSec ? t('passwordsDoNotMatch') : false,
        })
      }

    } else {
      if (form.email) {
        const reseturl = `${window.location.origin}${pathname}`
        const body = { login: form.email, reseturl }
        fetch(body, passwordForgot)

      } else {
        setWarning({
          email: form.email ? t('wrongEmail') : false,
          password: false,
        })
      }
    }
  }

  const fetch = async (body, url) => {
    setStatus(STATUS.pending)
    try {
      const response = await POST(url, { body })
      if (response) {
        setStatus(STATUS.succeed)
        if (url === passwordReset) {
          replace(loginPath(body.login))
        }
      }

    } catch (err) {
      setStatus(STATUS.failed)
    }
  }

  const enterClicked = ref => {
    const index = refs.findIndex(r => Object.is(r, ref))
    if (index === -1) return
    if (refs[index + 1]) refs[index + 1].focus()
    else if (index + 1 === refs.length && !isLoading) submit()
  }

  return (
    <div className='reset__password'>
      <div className='reset__title title'>
        <div>{t(isOnBoarding ? 'setAPassword' : 'passwordReset')}</div>
      </div>

      <div className='reset__main main center'>
        <div className='reset__form form'>
          <Input
            disabled={isLoading || isToken}
            value={form.email || ''}
            name='email'
            minLength='1'
            maxLength='200'
            autoComplete='username'
            label={t('phoneNumberOrEmail')}
            warning={warning.email}
            placeholder={t('phoneNumberOrEmail')}
            changeHandler={changeHandler} />

          {isToken && <>
            <Input
              required
              ref={r => refs.push(r)}
              value={form.password || ''}
              name='password'
              type='password'
              label={t('newPassword')}
              minLength='8'
              maxLength='100'
              disabled={isLoading}
              autoComplete='new-password'
              warning={warning.password}
              placeholder={t('enterANewPassword')}
              blurHandler={blurHandler}
              enterClicked={enterClicked}
              changeHandler={changeHandler} />

            <Input
              required
              ref={r => refs.push(r)}
              value={form.passwordSec || ''}
              name='passwordSec'
              type='password'
              label={t('repeatNewPassword')}
              minLength='8'
              maxLength='100'
              disabled={isLoading}
              autoComplete='new-password'
              warning={warning.passwordSec}
              placeholder={t('reEnterNewPassword')}
              blurHandler={blurHandler}
              enterClicked={enterClicked}
              changeHandler={changeHandler} />
          </>}

          <Submit
            isLoading={isLoading}
            text={t('resetPassword')}
            action={() => {
              status !== STATUS.pending && submit()
            }} />
        </div>
      </div>
    </div>
  )
}

export default Reset